/**
 * Environment Configuration
 *
 * Centralizes access to environment variables with type safety.
 * All environment variables should be accessed through this module.
 */

interface EnvironmentConfig {
  app: {
    name: string;
    version: string;
    env: string;
  };
  api: {
    baseURL: string;
    timeout: number;
  };
}

function getEnvVariable(key: string, defaultValue?: string): string {
  const value = import.meta.env[key];
  if (value === undefined && defaultValue === undefined) {
    throw new Error(`Environment variable ${key} is required but not defined`);
  }
  return value ?? defaultValue ?? '';
}

export const env: EnvironmentConfig = {
  app: {
    name: getEnvVariable('VITE_APP_NAME', 'fe-incidentes-idx'),
    version: getEnvVariable('VITE_APP_VERSION', '0.1.0'),
    env: getEnvVariable('VITE_ENV', 'development'),
  },
  api: {
    baseURL: getEnvVariable(
      'VITE_API_BASE_URL',
      'http://localhost:8000/api'
    ),
    timeout: parseInt(getEnvVariable('VITE_API_TIMEOUT', '30000'), 10),
  },
};

/**
 * Check if the app is running in development mode
 */
export const isDevelopment = (): boolean => env.app.env === 'development';

/**
 * Check if the app is running in production mode
 */
export const isProduction = (): boolean => env.app.env === 'production';
